import { FaRegCircleCheck } from "react-icons/fa6";

const GradientCheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#a855f7" />
        <stop offset="50%" stopColor="#6366f1" />
        <stop offset="100%" stopColor="#3b82f6" />
      </linearGradient>
    </defs>
    <FaRegCircleCheck
      style={{ fill: "url(#gradient)", width: "100%", height: "100%" }}
    />
  </svg>
);

export default GradientCheckIcon;
